var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"oto-fab-container",class:{ 'is-hidden-tablet':_vm.props.mobileOnly }},[_c('a',{staticClass:"oto-fab-button",on:{"click":function($event){return _vm.click()}}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-small has-text-white"},[_c('i',{staticClass:"fas fa-plus"})])
}]

export { render, staticRenderFns }